var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"relative w-full mb-30",attrs:{"title":_vm.$t('health_actions.details.overview'),"icon":"Clipboard","accentColor":"sky"}},[_c('Markdown',{staticClass:"p-20 overflow-x-auto",attrs:{"source":_vm.longDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }